
/*
 *   File : index.js
 *   Author URI : https://evoqueinnovativelab.com
 *   Description : Index file for banner container;
 *   Integrations : 22-08-2022
 *   Version : v1.0
 *   Created : 08-08-2022
*/
/*import packages*/
import React, { useEffect, useState } from 'react';
import $ from 'jquery'

/*import components*/
import { PrimaryBtn, SecondaryBtn } from '../../components/cta';
import { FundsTab } from '../../components/dataFormating';
import { FileUpload, Input, Radio } from '../../components/input';
import { Loader } from '../../components/loader';
import { Toast } from '../../components/note';

/*  import assets */
import Banner from '../../assets/images/banner/banner.svg';
import Preview from '../../assets/images/banner/preview.svg';
import LoaderImg from '../../assets/images/loader/mintd-loader.gif'

/* import services */
import devconfig from '../../config/config';
import APIPost from '../../services/postApi';
import APIGet from '../../services/getApi';
import { Confirmation } from '../../components/modal';
import SelectBox from '../../components/dropdown/selectBox';
import styles from '../../styles/components/fundTab.module.scss';

const TABS = [
    { id: 1, label: "Top" },
    { id: 3, label: 'Bottom' },
    { id: 2, label: "Unused" },
    { id: 5, label: "Sliding Banner" }
]

/* Recommended upload dimensions per banner type — surfaced next to each
 * "Upload image" label so admins use correctly sized assets. */
const SLIDING_DIMENSION = "984 × 360 px";
const POPUP_DIMENSION = "328 × 420 px";
/* Keyed by the left-column tab id (Top / Bottom / Unused all share the
 * full-width top/bottom banner size). */
const BANNER_DIMENSIONS = {
    1: "2073 × 758 px", // Top
    2: "2073 × 758 px", // Unused
    3: "2073 × 758 px", // Bottom
    5: SLIDING_DIMENSION, // Sliding / Carousel
}

const Index = () => {
    const createEmptySlide = (contentType = 4) => ({
        url: "",
        preview: "",
        content_type: contentType,
        redirection: null,
        selectedBasket: null,
        selectedAms: null
    });
    /* Content type of the first slide, used to keep the selected radio option (e.g. AMS)
       after deleting — a fresh empty slot should not silently fall back to Basket. */
    const firstSlideContentType = (slides) => (slides && slides.length ? slides[0].content_type : 4);
    const [index, setIndex] = useState(1)
    const [url, setUrl] = useState("");
    const [popUpurl, setPopupUrl] = useState("");
    const [redirection, setRedirection] = useState(null);
    const [video, setVideo] = useState(4);
    const [loader, setLoader] = useState(false);
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(null);
    /* Image-dimension validation error — shown in a toast that stays open until
       the user closes it (unlike the auto-dismissing error/success toasts). */
    const [dimensionError, setDimensionError] = useState(null);
    const [dataLoader, setDataLoader] = useState(false);
    const [fileUpload, setFileUpload] = useState(false);
    const [previewUrl, setPreviewUrl] = useState("");
    const [popupPreviewUrl, setPopupPreviewUrl] = useState("");

    const [basketFilter, setBasketFilter] = useState([]);
    const [selectedBasket, setSelectedBasket] = useState(null);
    const [selectedPopupBasket, setSelectedPopupBasket] = useState(null);
    const [amsFilter, setAmsFilter] = useState([]);
    const [selectedAms, setSelectedAms] = useState(null);
    const [selectedPopupAms, setSelectedPopupAms] = useState(null);
    const [popUpRedirection, setPopUpRedirection] = useState(null);
    const [contentType, setContentType] = useState(null);
    const [popUpUrlType, setPopUpUrlType] = useState(1);
    const [slidingImages, setSlidingImages] = useState([createEmptySlide()]);
    const [slidingUploadIndex, setSlidingUploadIndex] = useState(null);
    /** Which delete action opened the modal: sliding (left + tab 5), main (left + other tab), popup (right column) */
    const [deleteModalTarget, setDeleteModalTarget] = useState("main");
    /* Whether a banner actually exists (saved via upsert with content) in the backend list.
       Delete is only allowed for saved banners — a freshly uploaded but unsaved banner has no
       record in the list, so deleting it returns "No data found". */
    const [mainBannerSaved, setMainBannerSaved] = useState(false);
    const [slidingBannerSaved, setSlidingBannerSaved] = useState(false);
    const [popupBannerSaved, setPopupBannerSaved] = useState(false);

    // const [bannerData, setBannerData] = useState([]);

    useEffect(() => {
        getBannerDetails(false, true, 1)
    }, []);

    useEffect(() => {
        _getBasketFilter();
    }, []);

    useEffect(() => {
        _getAmsFilter();
    }, []);

    useEffect(() => {
        if (error !== null) {
            setTimeout(() => {
                setError(null)
            }, 3000)
        }
    }, [error])

    useEffect(() => {
        if (success !== null) {
            setTimeout(() => {
                setSuccess(null)
            }, 3000)
        }
    }, [success])

    /*--------add banner api ---*/
    const addBanner = (item) => {
        //eslint-disable-next-line
        var regVideo = /^https?:\/\//;

        if (regVideo.test(item.redirection_url) || item.content_type >= 3) {
            if (item.content_type === 6 && !selectedAms) {
                setError("Please select AMS");
                return;
            }
            setLoader(1);
            let url = devconfig.admin + "/banner/upsert"

            let data = JSON.stringify({
                "banner_id": index,
                "image_url": item.image_url,
                "redirection_url": item.redirection_url ? item.redirection_url : null,
                "content_type": item.content_type,
                "goal_id": selectedBasket !== null ? selectedBasket.value : null,
                "ams_id": item.content_type === 6 && selectedAms ? selectedAms.value : null,
                "is_pop_up": false
            })

            APIPost(url, data).then((response) => {
                if (response.status_code === 200) {
                    setSuccess("Banner updated");
                    setLoader(false);
                    getBannerDetails(false, false, index)
                } else {
                    setLoader(false);
                    setError(response.message);
                }
            });
        } else {
            setError("Please add correct redirection url")
        }
    }

    /*--------add banner api ---*/
    const addPopupBanner = (item) => {
        //eslint-disable-next-line
        var regVideo = /^https?:\/\//;
        if (popUpUrlType === 1 && !regVideo.test(popUpRedirection)) {
            setError("Please add correct redirection url for pop up");
            return;
        }
        if (popUpUrlType === 4 && !selectedPopupAms) {
            setError("Please select AMS");
            return;
        }

        setLoader(2);
        let url = devconfig.admin + "/banner/upsert"

        let data = JSON.stringify({
            "banner_id": 4,
            "image_url": item.image_url,
            "redirection_url": popUpRedirection !== null ? popUpRedirection : null,
            "content_type": popUpUrlType === 1 ? 2 : popUpUrlType === 4 ? 6 : 4,
            "goal_id": selectedPopupBasket !== null ? selectedPopupBasket.value : null,
            "ams_id": popUpUrlType === 4 && selectedPopupAms ? selectedPopupAms.value : null,
            "is_pop_up": true
        })

        APIPost(url, data).then((response) => {
            if (response.status_code === 200) {
                setSuccess("Banner updated");
                setLoader(false);
                getBannerDetails(false, false, index)
            } else {
                setLoader(false);
                setError(response.message);
            }
        });

    }

    /*--------add sliding banner api ---*/
    const addSlidingBanner = () => {
        //eslint-disable-next-line
        var regVideo = /^https?:\/\//;
        const filled = slidingImages.filter((item) => item.url);
        if (filled.length === 0) {
            setError("Please upload at least one sliding banner image");
            return;
        }
        for (let i = 0; i < filled.length; i++) {
            const s = filled[i];
            if (s.content_type < 3 && !regVideo.test(s.redirection || "")) {
                setError("Please add correct redirection url");
                return;
            }
            if (s.content_type === 4 && !s.selectedBasket) {
                setError("Please select basket");
                return;
            }
            if (s.content_type === 6 && !s.selectedAms) {
                setError("Please select AMS");
                return;
            }
        }

        const imageUrls = filled.map((item) => ({
            image_url: item.url,
            content_type: item.content_type,
            goal_id: item.content_type === 4 && item.selectedBasket ? item.selectedBasket.value : null,
            ams_id: item.content_type === 6 && item.selectedAms ? item.selectedAms.value : null,
            redirection_url: item.content_type < 3 ? (item.redirection ? item.redirection : null) : null
        }));

        setLoader(1);
        let url = devconfig.admin + "/banner/upsert"

        let data = JSON.stringify({
            "banner_id": 5,
            "image_url": null,
            "image_urls": imageUrls,
            "redirection_url": null,
            "content_type": 5,
            "goal_id": null,
            "is_pop_up": false
        })

        APIPost(url, data).then((response) => {
            if (response.status_code === 200) {
                setSuccess("Banner updated");
                setLoader(false);
                getBannerDetails(false, false, 5)
            } else {
                setLoader(false);
                setError(response.message);
            }
        });
    }
    // 
    const _getBasketFilter = () => {
        const url = devconfig.admin + "/banner/basket-filter";
        APIGet(url).then((response) => {
            if (response.status_code === 200) {
                const basket_filter = [];
                response.data.map((item) => {
                    return (
                        basket_filter.push({
                            value: item.id,
                            ...item
                        })
                    )
                })
                setBasketFilter(basket_filter)
            }
        })
    }

    const _getAmsFilter = () => {
        const url = devconfig.admin + "/banner/ams-filter";
        APIGet(url).then((response) => {
            if (response.status_code === 200) {
                const ams_filter = [];
                response.data.map((item) => {
                    return (
                        ams_filter.push({
                            value: item.id,
                            ...item
                        })
                    )
                })
                setAmsFilter(ams_filter)
            }
        })
    }

    /*--------get banner api ---*/
    const getBannerDetails = (is_delete, status, tempIndex) => {

        // setIndex(tempIndex)
        setDataLoader(status);

        let url = devconfig.admin + "/banner/get";

        APIGet(url).then((response) => {
            if (response.status_code === 200) {
                setDataLoader(false);
                let tempBannerData = response.data.sort((a, b) => a.banner_id - b.banner_id).filter((item) => item.is_pop_up !== true);
                let tempBannerData1 = response.data.sort((a, b) => a.banner_id - b.banner_id).filter((item) => item.is_pop_up === true);

                /* Track which banners are actually saved (present in the list with content) so the
                   Delete buttons are only enabled for them. Computed from the raw backend record,
                   independent of any locally-uploaded-but-unsaved image. */
                const savedMainRecord = tempBannerData.find((item) => item.banner_id === tempIndex);
                if (tempIndex === 5) {
                    const savedSlides = savedMainRecord
                        ? (Array.isArray(savedMainRecord.image_urls)
                            ? savedMainRecord.image_urls
                            : (savedMainRecord.slide_details || savedMainRecord.slides || []))
                        : [];
                    const hasSavedSlide = (Array.isArray(savedSlides) && savedSlides.some((s) => s && (typeof s === "object" ? (s.image_url || s.url) : s)))
                        || !!(savedMainRecord && savedMainRecord.image_url);
                    setSlidingBannerSaved(!!hasSavedSlide);
                } else {
                    setMainBannerSaved(!!(savedMainRecord && savedMainRecord.image_url));
                }
                const savedPopupRecord = tempBannerData1.find((item) => item.banner_id === 4) || tempBannerData1[0];
                setPopupBannerSaved(!!(savedPopupRecord && savedPopupRecord.image_url));

                const BANNER_INDEX = tempBannerData.findIndex((item) => item.banner_id === tempIndex);

                if (BANNER_INDEX !== -1) {
                    if (tempIndex === 5) {
                        const row = tempBannerData[BANNER_INDEX];
                        const mapSlideObject = (slideObj) => {
                            const imageUrl = slideObj && (slideObj.image_url || slideObj.url) ? (slideObj.image_url || slideObj.url) : "";
                            const gid = slideObj && slideObj.goal_id != null ? slideObj.goal_id : null;
                            const fromFilter = gid != null && basketFilter.length
                                ? basketFilter.find((b) => b.value === gid)
                                : null;
                            const amsId = slideObj && slideObj.ams_id != null ? slideObj.ams_id : null;
                            const amsFromFilter = amsId != null && amsFilter.length
                                ? amsFilter.find((a) => a.value === amsId)
                                : null;
                            return {
                                url: imageUrl,
                                preview: imageUrl,
                                content_type: slideObj && slideObj.content_type != null ? slideObj.content_type : 4,
                                redirection: slideObj && slideObj.redirection_url != null ? slideObj.redirection_url : null,
                                selectedBasket: gid != null
                                    ? { label: (fromFilter && fromFilter.label) || (slideObj && slideObj.goal_name) || "", value: gid }
                                    : null,
                                selectedAms: amsId != null
                                    ? { label: (amsFromFilter && amsFromFilter.label) || (slideObj && slideObj.ams_name) || "", value: amsId }
                                    : null
                            };
                        };
                        const mapSlide = (imageUrl, i, ctArr, redArr, goalArr, nameArr, amsArr, amsNameArr) => {
                            const ct = ctArr[i] != null ? ctArr[i] : 4;
                            const gid = goalArr[i] != null ? goalArr[i] : null;
                            const gname = nameArr && nameArr[i] != null ? nameArr[i] : null;
                            const fromFilter = gid != null && basketFilter.length
                                ? basketFilter.find((b) => b.value === gid)
                                : null;
                            const amsId = amsArr && amsArr[i] != null ? amsArr[i] : null;
                            const amsName = amsNameArr && amsNameArr[i] != null ? amsNameArr[i] : null;
                            const amsFromFilter = amsId != null && amsFilter.length
                                ? amsFilter.find((a) => a.value === amsId)
                                : null;
                            return {
                                url: imageUrl || "",
                                preview: imageUrl || "",
                                content_type: ct,
                                redirection: redArr[i] != null ? redArr[i] : null,
                                selectedBasket: gid != null
                                    ? { label: (fromFilter && fromFilter.label) || gname || "", value: gid }
                                    : null,
                                selectedAms: amsId != null
                                    ? { label: (amsFromFilter && amsFromFilter.label) || amsName || "", value: amsId }
                                    : null
                            };
                        };

                        setVideo(5);
                        const slideImageUrls = Array.isArray(row.image_urls) ? row.image_urls : [];
                        const slideDetailsList = row.slide_details || row.slides;
                        if (slideImageUrls.length > 0 && typeof slideImageUrls[0] === "object" && !Array.isArray(slideImageUrls[0])) {
                            setSlidingImages(slideImageUrls.map((sd) => mapSlideObject(sd)));
                        } else if (slideDetailsList && Array.isArray(slideDetailsList) && slideDetailsList.length > 0) {
                            setSlidingImages(slideDetailsList.map((sd) => mapSlideObject(sd)));
                        } else {
                            const slideUrls = slideImageUrls.length > 0
                                ? slideImageUrls
                                : row["image_url"]
                                    ? [row["image_url"]]
                                    : [""];
                            if (!slideUrls.some((u) => u)) {
                                // No saved slides — keep one empty slot but preserve the selected radio option
                                setSlidingImages((prev) => [createEmptySlide(firstSlideContentType(prev))]);
                            } else {
                                const ctArr = row.content_types || row.slide_content_types || [];
                                const redArr = row.redirection_urls || row.slide_redirection_urls || [];
                                const goalArr = row.goal_ids || row.slide_goal_ids || [];
                                const nameArr = row.goal_names || row.slide_goal_names || [];
                                const amsArr = row.ams_ids || row.slide_ams_ids || [];
                                const amsNameArr = row.ams_names || row.slide_ams_names || [];
                                setSlidingImages(slideUrls.map((u, i) => mapSlide(u, i, ctArr, redArr, goalArr, nameArr, amsArr, amsNameArr)));
                            }
                        }
                        setUrl("");
                        setPreviewUrl("");
                        setRedirection(null);
                        setSelectedBasket(null);
                        setSelectedAms(null);
                    } else {
                        setVideo(tempBannerData[BANNER_INDEX]["content_type"]);
                        setUrl(tempBannerData[BANNER_INDEX]["image_url"]);
                        setPreviewUrl(tempBannerData[BANNER_INDEX]["image_url"]);
                        setRedirection(tempBannerData[BANNER_INDEX]["redirection_url"]);
                        setSelectedBasket(tempBannerData[BANNER_INDEX]["goal_id"] !== null ? { label: tempBannerData[BANNER_INDEX]["goal_name"], value: tempBannerData[BANNER_INDEX]["goal_id"] } : null);
                        setSelectedAms(tempBannerData[BANNER_INDEX]["ams_id"] != null ? { label: tempBannerData[BANNER_INDEX]["ams_name"], value: tempBannerData[BANNER_INDEX]["ams_id"] } : null);
                    }
                    tempBannerData1 = tempBannerData1.filter((item) => item.is_pop_up === true);
                    console.log(status, tempBannerData1)
                    if (tempBannerData1.length > 0) {
                        const popupItem = tempBannerData1.find((b) => b.banner_id === 4) || tempBannerData1[0];
                        setPopupUrl(popupItem["image_url"]);
                        setPopupPreviewUrl(popupItem["image_url"]);
                        setSelectedPopupBasket(popupItem["goal_id"] !== null ? { label: popupItem["goal_name"], value: popupItem["goal_id"] } : null);
                        setSelectedPopupAms(popupItem["ams_id"] != null ? { label: popupItem["ams_name"], value: popupItem["ams_id"] } : null);
                    }
                } else {
                    if (contentType === 4) {
                        setPopupUrl("");
                        setPopupPreviewUrl("");
                        setSelectedPopupBasket(null);
                        setContentType(null)
                    } else {
                        if (tempIndex === 5) {
                            setSlidingImages((prev) => [createEmptySlide(firstSlideContentType(prev))]);
                        } else {
                            setUrl("");
                            setPreviewUrl("");
                            setRedirection("");
                            setSelectedBasket(null);
                        }
                    }
                }
            } else {
                setDataLoader(false);
                setMainBannerSaved(false);
                setSlidingBannerSaved(false);
                setPopupBannerSaved(false);
            }
        })
    }


    const onChangeValue = (e) => {
        setVideo(Number(e.target.value))
    }

    const slideFieldsValid = (slide) => {
        if (!slide.url) return false;
        if (slide.content_type < 3) {
            return slide.redirection && /^https?:\/\//.test(slide.redirection);
        }
        if (slide.content_type === 4) {
            return !!slide.selectedBasket;
        }
        if (slide.content_type === 6) {
            return !!slide.selectedAms;
        }
        return true;
    };

    const getFields = () => {
        if (index === 5) {
            return slidingImages.length > 0 && slidingImages.every((item) => slideFieldsValid(item));
        }
        if (video === 6) {
            return !!(url && selectedAms);
        }
        if (video < 3) {
            if (url && redirection) {
                return true
            }
        } if (video === 4) {
            if (url && selectedBasket) {
                return true
            }
        } else {
            if (url) {
                return true
            }
        }
        return false
    }

    /* Delete on the left column is only allowed when a saved banner exists for the active tab.
       Prevents deleting a freshly-uploaded-but-unsaved banner (which 400s with "No data found"). */
    const canDeleteMainColumn = () => index === 5 ? slidingBannerSaved : mainBannerSaved;

    const onAddSlide = () => {
        setSlidingImages((prev) => [...prev, createEmptySlide()]);
    }

    const onDeleteSlide = (slideIndex) => {
        if (slidingImages.length === 1) {
            setSlidingImages([createEmptySlide()]);
            return;
        }
        setSlidingImages((prev) => prev.filter((item, idx) => idx !== slideIndex));
        if (slidingUploadIndex === slideIndex) {
            setSlidingUploadIndex(null);
        }
    }

    const uploadFile = (temp, type, slideIndex = null) => {
        /* Banner assets must match the recommended size for the active surface.
           Validate the selected image first; block the upload on a mismatch. */
        const requiredDimension = slideIndex !== null ? SLIDING_DIMENSION : type === 2 ? POPUP_DIMENSION : BANNER_DIMENSIONS[index];
        const [reqWidth, reqHeight] = requiredDimension.match(/\d+/g).map(Number);

        const img = new Image();
        img.onload = () => {
            if (img.naturalWidth !== reqWidth || img.naturalHeight !== reqHeight) {
                setDimensionError(`Please upload an image with dimensions ${requiredDimension}.`);
                // revert the just-set preview so the invalid image isn't shown
                if (slideIndex !== null) {
                    setSlidingImages((prev) => prev.map((item, idx) => idx === slideIndex ? { ...item, preview: item.url } : item));
                } else if (type === 2) {
                    setPopupPreviewUrl(popUpurl);
                } else {
                    setPreviewUrl(url);
                }
                return;
            }

            if (slideIndex !== null) {
                setSlidingUploadIndex(slideIndex)
            } else {
                setFileUpload(type)
            }
            let uploadUrl = devconfig.admin + '/file/upload'

            let data = JSON.stringify({
                type: "BANNER",
                file: temp.name,
                is_public: true,
            })

            APIPost(uploadUrl, data).then((response) => {
                if (response.status_code === 200) {
                    if (slideIndex === null) {
                        setFileUpload(true)
                    }
                    uploadDocument(response.data, temp, type, slideIndex); // upload file in AWS s3
                } else {
                    setError(response.message);
                    if (slideIndex !== null) {
                        setSlidingUploadIndex(null)
                    } else {
                        setFileUpload(false)
                    }
                }
            })
        };
        img.src = URL.createObjectURL(temp);
    }

    /* Uploading to s3 */
    const uploadDocument = async (data, file, type, slideIndex = null) => {
        if (slideIndex === null) {
            setFileUpload(type)
        }

        var formdata = new FormData();
        formdata.append("key", data.upload_info.fields.key);
        formdata.append("x-amz-algorithm", data.upload_info.fields['x-amz-algorithm']);
        formdata.append("x-amz-credential", data.upload_info.fields['x-amz-credential']);
        formdata.append("x-amz-date", data.upload_info.fields['x-amz-date']);
        formdata.append("policy", data.upload_info.fields['policy']);
        formdata.append("x-amz-signature", data.upload_info.fields['x-amz-signature']);
        formdata.append("file", file, file.name);

        var requestOptions = {
            method: 'POST',
            body: formdata,
            redirect: 'follow'
        };

        fetch(data.upload_info.url, requestOptions)
            .then(response => response.text())
            .then(result => {
                if (slideIndex !== null) {
                    setSlidingUploadIndex(null)
                    setSlidingImages((prev) => prev.map((item, idx) => idx === slideIndex ? { ...item, url: data.view_info, preview: data.view_info } : item))
                } else {
                    setFileUpload(false)
                    if (type === 1) {
                        setUrl(data.view_info);
                    } else {
                        setPopupUrl(data.view_info)
                    }
                }
            })
            .catch(error => {
                if (slideIndex !== null) {
                    setSlidingUploadIndex(null)
                    setError("Failed to upload image");
                } else {
                    setFileUpload(false)
                }
            });
    }

    return (
        dataLoader ?
            <Loader />
            :
            <div className="row">
                <div className="col-lg-6">
                    <div className="card border-0 e-dashboard-card pt-4 px-4 pb-2">
                        <div className="col-lg-12  mb-3 e-border pb-1 e-allcation-accordion">

                            {
                                TABS.map((item, key) => {
                                    return (
                                        <span
                                            className={index === item.id ? `${styles.e_active_tab} me-4 e-active-tab` : `${styles.e_tab} me-4 e-tab`}
                                            onClick={() => { setIndex(item.id); getBannerDetails(false, false, item.id) }} key={key}
                                        >
                                            {item.label}
                                        </span>
                                    )
                                })
                            }
                        </div>
                        <div className='row px-2'>
                            <div className="col-lg-12 ">
                                {
                                    index === 5 ?
                                        <div className='row px-2'>
                                            {/* <label className='mb-2 px-0'>Sliding banner images ({SLIDING_DIMENSION})</label> */}
                                            {
                                                slidingImages.map((slide, slideIndex) => {
                                                    const uploadId = `e-upload-slide-${slideIndex}`;
                                                    return (
                                                        <div key={slideIndex} className={slideIndex > 0 ? "border-top pt-3 mb-3" : "mb-3"}>
                                                            <div className="col-lg-12 pe-0">
                                                                <div className="d-flex w-100 justify-content-between align-items-center">
                                                                    <label className="mb-2 px-0 pb-0">Upload image ({SLIDING_DIMENSION})</label>
                                                                    {
                                                                        slideIndex > 0 ?
                                                                            <p
                                                                                className="e-remove-attachment mb-0"
                                                                                onClick={() => onDeleteSlide(slideIndex)}
                                                                            >
                                                                                Remove attachment
                                                                            </p>
                                                                            :
                                                                            null
                                                                    }
                                                                </div>
                                                                <div className="d-flex col-lg-12 ps-2 flex-wrap mb-2">
                                                                    <Radio
                                                                        id={`slide-${slideIndex}-ct-1`}
                                                                        name={`slide-content-${slideIndex}`}
                                                                        value={1}
                                                                        checked={slide.content_type === 1}
                                                                        label="Video"
                                                                        valueClick={(val) => {
                                                                            setSlidingImages((prev) => prev.map((item, idx) => idx === slideIndex ? { ...item, content_type: Number(val) } : item));
                                                                        }}
                                                                    />
                                                                    <Radio
                                                                        id={`slide-${slideIndex}-ct-2`}
                                                                        name={`slide-content-${slideIndex}`}
                                                                        value={2}
                                                                        checked={slide.content_type === 2}
                                                                        label="Link"
                                                                        valueClick={(val) => {
                                                                            setSlidingImages((prev) => prev.map((item, idx) => idx === slideIndex ? { ...item, content_type: Number(val) } : item));
                                                                        }}
                                                                    />
                                                                    <Radio
                                                                        id={`slide-${slideIndex}-ct-3`}
                                                                        name={`slide-content-${slideIndex}`}
                                                                        value={3}
                                                                        checked={slide.content_type === 3}
                                                                        label="Message"
                                                                        valueClick={(val) => {
                                                                            setSlidingImages((prev) => prev.map((item, idx) => idx === slideIndex ? { ...item, content_type: Number(val) } : item));
                                                                        }}
                                                                    />
                                                                    <Radio
                                                                        id={`slide-${slideIndex}-ct-4`}
                                                                        name={`slide-content-${slideIndex}`}
                                                                        value={4}
                                                                        checked={slide.content_type === 4}
                                                                        label="Basket"
                                                                        valueClick={(val) => {
                                                                            setSlidingImages((prev) => prev.map((item, idx) => idx === slideIndex ? { ...item, content_type: Number(val) } : item));
                                                                        }}
                                                                    />
                                                                    <Radio
                                                                        id={`slide-${slideIndex}-ct-6`}
                                                                        name={`slide-content-${slideIndex}`}
                                                                        value={6}
                                                                        checked={slide.content_type === 6}
                                                                        label="AMS"
                                                                        valueClick={(val) => {
                                                                            setSlidingImages((prev) => prev.map((item, idx) => idx === slideIndex ? { ...item, content_type: Number(val) } : item));
                                                                        }}
                                                                    />
                                                                </div>
                                                                {
                                                                    slide.preview ?
                                                                        <div className='e-preview position-relative mb-2 p-0'>
                                                                            {
                                                                                slidingUploadIndex === slideIndex ?
                                                                                    <img src={LoaderImg} alt="" height="60px" width="100%" style={{ objectFit: "contain", marginTop: "20px" }} />
                                                                                    :
                                                                                    <img src={slide.preview} alt="" height="100%" width="100%" style={{ objectFit: "cover" }} />
                                                                            }
                                                                            <span className='e-choose-btn' onClick={() => { $(`#${uploadId}`).trigger("click") }}>
                                                                                <img src={Preview} alt="" height="30px" width="30px" className='me-2' />
                                                                                Change image
                                                                            </span>
                                                                            <FileUpload
                                                                                accept={" application/pdf, image/*"}
                                                                                className="d-none"
                                                                                id={uploadId}
                                                                                key={`e-upload-image-${slideIndex}`}
                                                                                upload={(temp) => {
                                                                                    const preview = URL.createObjectURL(temp);
                                                                                    setSlidingImages((prev) => prev.map((item, idx) => idx === slideIndex ? { ...item, preview } : item))
                                                                                    uploadFile(temp, 1, slideIndex)
                                                                                }} />
                                                                        </div>
                                                                        :
                                                                        <div className="e-uploader mb-2" onClick={() => { $(`#${uploadId}`).click() }}>
                                                                            <div className='text-center'>
                                                                                <img src={Banner} alt="" height="40px" className='text-center' />
                                                                                <p className='text-center mb-2'>
                                                                                    Upload an image
                                                                                </p>
                                                                            </div>
                                                                            <FileUpload
                                                                                accept={" application/pdf, image/*"}
                                                                                className="d-none"
                                                                                id={uploadId}
                                                                                key={`e-upload-image-${slideIndex}`}
                                                                                upload={(temp) => {
                                                                                    const preview = URL.createObjectURL(temp);
                                                                                    setSlidingImages((prev) => prev.map((item, idx) => idx === slideIndex ? { ...item, preview } : item))
                                                                                    uploadFile(temp, 1, slideIndex)
                                                                                }} />
                                                                        </div>
                                                                }
                                                                {
                                                                    slide.content_type < 3 ?
                                                                        <div className='row mt-3 pt-2 px-0'>
                                                                            <label className='mb-2'>Redirection link</label>
                                                                            <Input
                                                                                value={slide.redirection}
                                                                                placeholder="url"
                                                                                valueChange={(temp) => {
                                                                                    setSlidingImages((prev) => prev.map((item, idx) => idx === slideIndex ? { ...item, redirection: temp !== "" ? temp : null } : item));
                                                                                }} />
                                                                        </div>
                                                                        :
                                                                        null
                                                                }
                                                                {
                                                                    slide.content_type === 4 ?
                                                                        <div className='row mt-3 pt-2 px-0'>
                                                                            <label className='mb-2'>Select Basket</label>
                                                                            <SelectBox
                                                                                value={slide.selectedBasket}
                                                                                placeholder="Goal"
                                                                                options={basketFilter}
                                                                                selectchange={(temp) => {
                                                                                    setSlidingImages((prev) => prev.map((item, idx) => idx === slideIndex ? { ...item, selectedBasket: temp } : item));
                                                                                }} />
                                                                        </div>
                                                                        :
                                                                        null
                                                                }
                                                                {
                                                                    slide.content_type === 6 ?
                                                                        <div className='row mt-3 pt-2 px-0'>
                                                                            <label className='mb-2'>Select AMS</label>
                                                                            <SelectBox
                                                                                value={slide.selectedAms}
                                                                                placeholder="AMS"
                                                                                options={amsFilter}
                                                                                selectchange={(temp) => {
                                                                                    setSlidingImages((prev) => prev.map((item, idx) => idx === slideIndex ? { ...item, selectedAms: temp } : item));
                                                                                }} />
                                                                        </div>
                                                                        :
                                                                        null
                                                                }
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                            <p className="e-add-attachment-btn" onClick={onAddSlide}>
                                                + Add new attachment
                                            </p>
                                        </div>
                                        :
                                        <>
                                            <div className='row mb-2'>
                                                <div onChange={(e) => onChangeValue(e)} className="d-flex col-lg-12 ps-2">
                                                    <Radio id={1} value={1} checked={video === 1 ? true : false} label="Video" />
                                                    <Radio id={2} value={2} checked={video === 2 ? true : false} label="Link" />
                                                    <Radio id={3} value={3} checked={video === 3 ? true : false} label="Message" />
                                                    <Radio id={4} value={4} checked={video === 4 ? true : false} label="Basket" />
                                                    <Radio id={6} value={6} checked={video === 6 ? true : false} label="AMS" />

                                                </div>
                                            </div>
                                            <div className='row px-2'>
                                                <label className='mb-2 px-0'>Banner image ({BANNER_DIMENSIONS[index]})</label>

                                                {
                                                    previewUrl ?
                                                        <div className='e-preview position-relative mb-3 p-0'>
                                                            {
                                                                fileUpload === 1 ?
                                                                    <img src={LoaderImg} alt="" height="60px" width="100%" style={{ objectFit: "contain", marginTop: "20px" }} />
                                                                    :
                                                                    <img src={previewUrl} alt="" height="100%" width="100%" style={{ objectFit: "cover" }} />
                                                            }
                                                            <span className='e-choose-btn' onClick={() => { $('#e-upload').trigger("click") }}>
                                                                <img src={Preview} alt="" height="30px" width="30px" className='me-2' />
                                                                Change image
                                                            </span>
                                                            {/* <span className='e-drag-text'>(Drag and drop image or click here to select image)</span> */}
                                                            <FileUpload
                                                                accept={" application/pdf, image/*"}
                                                                className="d-none"
                                                                id="e-upload"
                                                                key="e-upload-image"
                                                                upload={(temp) => {
                                                                    // setUploadImage(temp.name)
                                                                    let preview = URL.createObjectURL(temp);
                                                                    setPreviewUrl(preview)
                                                                    uploadFile(temp, 1)
                                                                }} />
                                                        </div>
                                                        :
                                                        <>
                                                            <div className="e-uploader mb-3" onClick={() => { $('#e-upload').click() }}>
                                                                <div className='text-center'>
                                                                    <img src={Banner} alt="" height="40px" className='text-center' />
                                                                    <p className='text-center mb-2'>
                                                                        Upload an image
                                                                    </p>
                                                                    {/* 
                                                                        video !== 1 ?
                                                                        <span className='e-drag-text'>(Drag and drop image or click here to select image)</span>
                                                                        :
                                                                        null */}
                                                                </div>
                                                                <FileUpload
                                                                    accept={" application/pdf, image/*"}
                                                                    className="d-none"
                                                                    id="e-upload"
                                                                    key="e-upload-image"
                                                                    upload={(temp) => {
                                                                        // setUploadImage(temp.name)
                                                                        let preview = URL.createObjectURL(temp);
                                                                        setPreviewUrl(preview)
                                                                        uploadFile(temp, 1)
                                                                    }} />
                                                            </div>
                                                        </>
                                                }
                                            </div>

                                            {
                                                video < 3 ?
                                                    <div className='row mt-3 pt-2'>
                                                        <label className='mb-2'>Redirection link</label>
                                                        <Input
                                                            value={redirection}
                                                            placeholder="url"
                                                            valueChange={(temp) => {
                                                                if (temp !== "") {
                                                                    setRedirection(temp)
                                                                } else {
                                                                    setRedirection(null)
                                                                }
                                                            }} />
                                                    </div>
                                                    :
                                                    null
                                            }
                                            {
                                                video === 4 ?
                                                    <div className='row mt-3 pt-2'>
                                                        <label className='mb-2'>Select Basket</label>
                                                        <SelectBox
                                                            value={selectedBasket}
                                                            placeholder="Goal"
                                                            options={basketFilter}
                                                            selectchange={(temp) => {
                                                                setSelectedBasket(temp)
                                                            }} />
                                                    </div>
                                                    :
                                                    null
                                            }
                                            {
                                                video === 6 ?
                                                    <div className='row mt-3 pt-2'>
                                                        <label className='mb-2'>Select AMS</label>
                                                        <SelectBox
                                                            value={selectedAms}
                                                            placeholder="AMS"
                                                            options={amsFilter}
                                                            selectchange={(temp) => {
                                                                setSelectedAms(temp)
                                                            }} />
                                                    </div>
                                                    :
                                                    null
                                            }
                                        </>
                                }

                            </div>

                            <div className="col-lg-12 text-end mb-3 mt-5">
                                {
                                    canDeleteMainColumn() ?
                                        <SecondaryBtn name={index === 5 ? "Delete all" : "Delete"}
                                            className="e-delete me-2"
                                            toggle="modal"
                                            target="#confirmationEquity"
                                            handleClick={() => {
                                                setDeleteModalTarget(index === 5 ? "sliding" : "main");
                                                if (index !== 5) {
                                                    setContentType(null);
                                                }
                                            }} />
                                        :
                                        <SecondaryBtn name={index === 5 ? "Delete all" : "Delete"}
                                            className="e-delete me-2 e-disabled" />
                                }
                                {
                                    getFields() ?

                                        <PrimaryBtn name="Save"
                                            className={loader === 1 ? "e-btn-loader" : ""}
                                            handleClick={() => {
                                                if (index === 5) {
                                                    addSlidingBanner()
                                                } else {
                                                    addBanner({ image_url: url, redirection_url: redirection, content_type: video })
                                                }
                                            }} />
                                        :
                                        <PrimaryBtn name="Save"
                                            className="e-disabled"
                                        />
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6">
                    <div className="card border-0 e-dashboard-card pt-4 px-4 pb-2">
                        <div className='row px-2'>
                            <div className="col-lg-12 ">
                                <div className='row mb-1'>
                                    <div onChange={(e) => onChangeValue(e)} className="d-flex col-lg-12 ps-2">
                                        {/* <h6>Popup banner</h6> */}
                                        <h6>For pop up while login</h6>
                                    </div>
                                </div>
                                <div className='row mb-2'>
                                    <div onChange={(e) => { console.log('Number(e.target.value)', Number(e.target.value)); setPopUpUrlType(Number(e.target.value)) }} className="d-flex col-lg-12 ps-2">
                                        <Radio id="popup-1" value={1} checked={popUpUrlType === 1 ? true : false} label="Link" />
                                        <Radio id="popup-2" value={2} checked={popUpUrlType === 2 ? true : false} label="Basket" />
                                        <Radio id="popup-3" value={3} checked={popUpUrlType === 3 ? true : false} label="Message" />
                                        <Radio id="popup-4" value={4} checked={popUpUrlType === 4 ? true : false} label="AMS" />
                                    </div>
                                </div>
                                <div className='row px-2'>
                                    <label className='mb-2 px-0'>Banner image ({POPUP_DIMENSION})</label>

                                    {
                                        popupPreviewUrl ?
                                            <div className='e-preview position-relative mb-3 p-0'>
                                                {
                                                    fileUpload === 2 ?
                                                        <img src={LoaderImg} alt="" height="60px" width="100%" style={{ objectFit: "contain", marginTop: "20px" }} />
                                                        :
                                                        <img src={popupPreviewUrl} alt="" height="100%" width="100%" style={{ objectFit: "cover" }} />
                                                }
                                                <span className='e-choose-btn' onClick={() => { $('#e-upload1').trigger("click") }}>
                                                    <img src={Preview} alt="" height="30px" width="30px" className='me-2' />
                                                    Change image
                                                </span>
                                                {/* <span className='e-drag-text'>(Drag and drop image or click here to select image)</span> */}
                                                <FileUpload
                                                    accept={" application/pdf, image/*"}
                                                    className="d-none"
                                                    id="e-upload1"
                                                    key="e-upload-image"
                                                    upload={(temp) => {
                                                        // setUploadImage(temp.name)
                                                        let preview = URL.createObjectURL(temp);
                                                        setPopupPreviewUrl(preview)
                                                        uploadFile(temp, 2)
                                                    }} />
                                            </div>
                                            :
                                            <>
                                                <div className="e-uploader mb-3" onClick={() => { $('#e-upload1').click() }}>
                                                    <div className='text-center'>
                                                        <img src={Banner} alt="" height="40px" className='text-center' />
                                                        <p className='text-center mb-2'>
                                                            Upload an image
                                                        </p>
                                                        {/* 
                                                            video !== 1 ?
                                                            <span className='e-drag-text'>(Drag and drop image or click here to select image)</span>
                                                            :
                                                            null */}
                                                    </div>
                                                    <FileUpload
                                                        accept={" application/pdf, image/*"}
                                                        className="d-none"
                                                        id="e-upload1"
                                                        key="e-upload-image"
                                                        upload={(temp) => {
                                                            // setUploadImage(temp.name)
                                                            let preview = URL.createObjectURL(temp);
                                                            setPopupPreviewUrl(preview)
                                                            uploadFile(temp, 2)
                                                        }} />
                                                </div>
                                            </>
                                    }
                                </div>

                                <div className='row mt-3 pt-2'>
                                    {
                                        popUpUrlType === 1 ?
                                            <>
                                                <label className='mb-2'>Redirection link</label>
                                                <Input
                                                    value={popUpRedirection}
                                                    placeholder="url"
                                                    valueChange={(temp) => {
                                                        if (temp !== "") {
                                                            setPopUpRedirection(temp)
                                                        } else {
                                                            setPopUpRedirection(null)
                                                        }
                                                    }} />
                                            </>
                                            : popUpUrlType === 2 ?
                                                <>
                                                    <label className='mb-2'>Select Basket</label>
                                                    <SelectBox
                                                        value={selectedPopupBasket}
                                                        placeholder="Goal"
                                                        options={basketFilter}
                                                        selectchange={(temp) => {
                                                            setSelectedPopupBasket(temp)
                                                        }} />
                                                </>
                                                : popUpUrlType === 4 ?
                                                    <>
                                                        <label className='mb-2'>Select AMS</label>
                                                        <SelectBox
                                                            value={selectedPopupAms}
                                                            placeholder="AMS"
                                                            options={amsFilter}
                                                            selectchange={(temp) => {
                                                                setSelectedPopupAms(temp)
                                                            }} />
                                                    </>
                                                    :
                                                    null
                                    }

                                </div>


                            </div>

                            <div className="col-lg-12 text-end mb-3 mt-5">
                                {
                                    popupBannerSaved ?
                                        <SecondaryBtn name="Delete"
                                            className="e-delete me-2"
                                            toggle="modal"
                                            target="#confirmationEquity"
                                            handleClick={() => {
                                                setDeleteModalTarget("popup");
                                                setContentType(4);
                                            }} />
                                        :
                                        <SecondaryBtn name="Delete"
                                            className="e-delete me-2 e-disabled" />
                                }
                                {
                                    popUpurl &&
                                        (popUpUrlType === 1 ? popUpRedirection : popUpUrlType === 4 ? selectedPopupAms : selectedPopupBasket) ?

                                        <PrimaryBtn name="Save"
                                            className={loader === 2 ? "e-btn-loader" : ""}
                                            handleClick={() => {
                                                addPopupBanner({ image_url: popUpurl, redirection_url: null, content_type: video })
                                            }} />
                                        :
                                        <PrimaryBtn name="Save"
                                            className="e-disabled"
                                        />
                                }
                            </div>
                        </div>
                    </div >
                </div>
                {/* Error toast */}
                {
                    error !== null ?
                        <Toast data={error}
                            type="error"
                            id="1" />
                        :
                        null
                }

                {/* Success toast */}
                {
                    success !== null ?
                        <Toast data={success}
                            type="success"
                            id="2" />
                        :
                        null
                }

                {/* Image-dimension validation toast — stays until manually closed */}
                {
                    dimensionError !== null ?
                        <Toast data={dimensionError}
                            type="error"
                            id="3"
                            autoClose={false}
                            onClose={() => setDimensionError(null)} />
                        :
                        null
                }
                <Confirmation
                    title="Delete Confirmation"
                    modalTitle={deleteModalTarget === "sliding" ? "Delete all" : undefined}
                    content={
                        deleteModalTarget === "sliding"
                            ? "Are you sure you want to delete all sliding banner images? After confirmation, you will have one empty upload slot until you save new images."
                            : "Do you want to delete this banner?"
                    }
                    debt={false}
                    banner_id={deleteModalTarget === "sliding" ? 5 : deleteModalTarget === "popup" ? 4 : index}
                    btn_name={deleteModalTarget === "sliding" ? "Yes, delete all" : "Yes, delete"}
                    update={() => {
                        if (deleteModalTarget === "sliding") {
                            setSlidingUploadIndex(null);
                            setSlidingImages((prev) => [createEmptySlide(firstSlideContentType(prev))]);
                        }
                        getBannerDetails(false, false, index);
                        if (deleteModalTarget === "popup") {
                            setContentType(null);
                        }
                        setSuccess(
                            deleteModalTarget === "sliding"
                                ? "All sliding banner images were deleted."
                                : deleteModalTarget === "popup"
                                    ? "Pop-up banner deleted successfully."
                                    : "Banner deleted successfully."
                        );
                    }}
                    close={() => {

                    }}
                />
            </div>
    );
}



export default Index;